export const encodeMessage = (dateString: string, body?: unknown) => {
  const messageString = JSON.stringify(body) || "";

  const message = `${messageString}.${dateString}`;
  const encoder = new TextEncoder();
  const messageEncoded = encoder.encode(message);

  return messageEncoded;
};
